import { CallPopUpAgentActions } from "../../store/slices/voice_call_slice/call_popup_agent";
import { Collapse } from "antd";
import { Cookie } from "../../../src/base/utils";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { ROLES } from "../../base/constant";
import { doResetValuesAndEmptyTheReducers } from "../../base/utils";
import { sidebarActions } from "../../store/slices/main_layout_slice/sidebar_slice";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function ContactsMenu(props: any) {
  const dispatch = useDispatcher();
  const commonReducer: any = useSelector((state: any) => state.sideBar);
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const doNavigate = (navigateValues: any, selectedValue: any) => {
    dispatch(sidebarActions.leftMenuValues({ mainValue: "" }));
    dispatch(sidebarActions.contactsMenu({ contactsMenuValue: selectedValue }));
    navigate(navigateValues);
    doResetValuesAndEmptyTheReducers();
  };
  // const token: any = Cookie.get();
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  let agent = roleId && roleId.split(",").includes(ROLES.AGENT_ROLE_ID);

  return (
    <>
      <Collapse
        accordion
        defaultActiveKey={["1"]}
        expandIconPosition="end"
        className="menuAccordion"
        expandIcon={({ isActive }) => <span className="icon__DownarrowWhite16" />}
      >
        {!agent ? (
          <ul className="subMenuSmall">
            <li
              className={commonReducer.contactsMenuValue === "cd" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/contactscreen", "cd");
              }}
            >
              Contacts
            </li>

            <li
              className={commonReducer.contactsMenuValue === "bcl" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/BlockedContactsList", "bcl");
              }}
            >
              Blocked Contacts
            </li>
            <li
              className={commonReducer.contactsMenuValue === "dnd" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/DNDContactList", "dnd");
              }}
            >
              Do Not Disturb
            </li>
          </ul>
        ) : (
          <ul className="subMenuSmall">
            <li
              className={commonReducer.contactsMenuValue === "cd" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/contactscreen", "cd");
              }}
            >
              Contacts
            </li>
          </ul>
        )}
      </Collapse>
    </>
  );
}

export { ContactsMenu };
